"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParcelIntegrationClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
class ParcelIntegrationClient extends base_client_1.ApiBasicAuthClient {
    constructor(config = {}, serviceUrl = process.env.PARCEL_INTEGRATION_SERVICE_URL, authUser = process.env.PARCEL_INTEGRATION_BASIC_AUTH_USER, authPasswd = process.env.PARCEL_INTEGRATION_BASIC_AUTH_PASSWORD) {
        super(Object.assign(Object.assign({}, config), { baseURL: `${config.baseURL || serviceUrl}`, basicAuthPassword: authPasswd, basicAuthUser: authUser }));
        if (!serviceUrl) {
            commons_logs_1.log.warn("PARCEL_INTEGRATION_SERVICE_URL environment variable is not set");
        }
        if (!authUser || !authPasswd) {
            commons_logs_1.log.warn("PARCEL_INTEGRATION_BASIC_AUTH_USER and PARCEL_INTEGRATION_BASIC_AUTH_PASSWORD environment variables are not set");
        }
    }
    async markAsShipped(markAsShippedRequest) {
        const url = `/v1/orders/markAsShipped`;
        try {
            return await this.post(url, markAsShippedRequest);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, ["ORDER_NOT_FOUND"]);
        }
    }
    async markAsDelivered(markAsDeliveredRequest) {
        const url = `/v1/orders/markAsDelivered`;
        try {
            return await this.post(url, markAsDeliveredRequest);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, ["ORDER_NOT_FOUND"]);
        }
    }
    async createLabelGenerationJob(labelGenerationJobRequest) {
        try {
            return await this.postWithHeaders("/v2/job", labelGenerationJobRequest, {}, {
                "x-customer-id": labelGenerationJobRequest.sellerId,
            });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err);
        }
    }
}
exports.ParcelIntegrationClient = ParcelIntegrationClient;
//# sourceMappingURL=ParcelIntegrationClient.js.map